import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/.pnpm/next@14.2.3_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.100.0/node_modules/next/dist/client/image-component.js");
